module.exports = __webpack_public_path__ + "img/64200.95bfbfee.jpg";